import React, { Component } from "react";

export default class AllianceBusinessLogo extends Component {
  render() {
    return (
      <li className="nav-header">
        <div className="dropdown profile-element user-style">
          <div
            className="profile-element"
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src="/assets/img/business_logo.png"
              width="100%"
              height="10%"
              alt="Alliance Business Logo"
            />
          </div>
        </div>
        <div className="logo-element">
          {/* Marter */}
          <img
            className="rounded-circle"
            src={"/assets/img/Alliance_logo_svg.svg"}
            width="50px"
            height={"50px"}
            alt="Alliance Main Logo"
          />
        </div>
      </li>
    );
  }
}
